import _DTO from "./_DTO";

export default class DeviceAccessoryDTO extends _DTO {

  constructor(deviceAccessory) {
    super();
    this.accessory = deviceAccessory.accessory;
    this.quantity = deviceAccessory.quantity;
    this.subAccessories = DeviceAccessoryDTO.getMappedOrDefault(deviceAccessory, 'subAccessories', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
  }

}
